import { useState, useRef, useEffect } from 'react';
import { useNotifications } from './useNotifications';
import './AppNav.css';

// Shared bell + dropdown, factored out so employer nav locations
// (EmployerDashboard, MessagesPage's employer nav) can show the same
// notifications AppNav already renders for veterans, without duplicating
// the dropdown markup at each call site. Reuses AppNav.css's .nav-notif-*
// classes directly -- they were already self-contained, not coupled to
// AppNav's own structure.
export default function NotificationBell({ userId }) {
  const [notifOpen, setNotifOpen] = useState(false);
  const { notifications, unreadCount, handleClick, markAllRead, getLabel, getColor, timeAgo } = useNotifications(userId);
  const notifRef = useRef(null);

  useEffect(() => {
    function handleOutside(e) {
      if (notifRef.current && !notifRef.current.contains(e.target)) {
        setNotifOpen(false);
      }
    }
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, []);

  return (
    <div className="nav-notif-wrap" ref={notifRef}>
      <button type="button" className="nav-notif" aria-label="Notifications" aria-expanded={notifOpen} onClick={() => setNotifOpen(o => !o)}>
        <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/>
        </svg>
        {unreadCount > 0 && <span className="notif-dot"></span>}
      </button>

      {notifOpen && (
        <div className="notif-dropdown">
          <div className="notif-dropdown-header">
            <span>Notifications</span>
            {unreadCount > 0 && (
              <button className="notif-mark-all" onClick={markAllRead}>Mark all read</button>
            )}
          </div>
          <div className="notif-list">
            {notifications.length === 0 ? (
              <div className="notif-empty">No notifications yet</div>
            ) : (
              notifications.map(n => (
                <button type="button"
                  key={n.id}
                  className={`notif-item${n.read ? '' : ' notif-unread'}`}
                  onClick={() => { handleClick(n); setNotifOpen(false); }}
                >
                  <span className="notif-icon" style={{ '--dot': getColor(n.type) }} />
                  <div className="notif-body">
                    <p className="notif-text">{getLabel(n)}</p>
                    <span className="notif-time">{timeAgo(n.created_at)}</span>
                  </div>
                  {!n.read && <span className="notif-unread-dot"></span>}
                </button>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
